export const specRows = (m, t) => {
  const s = m.specs || {};
  const ev = m.powertrain === "EV";
  return [
    { key: "heart", label: ev ? t("battery") : t("engine"), value: ev ? `${s.battery_kwh} kWh` : `${s.engine_cc} cc` },
    { key: "power", label: t("power"), value: s.power || "—" },
    { key: "torque", label: t("torque"), value: s.torque || "—" },
    { key: "eff", label: ev ? t("range") : t("mileage"), value: ev ? `${s.range_km} km` : `${s.mileage_kmpl} km/l` },
    { key: "kerb", label: t("kerbWeight"), value: `${s.kerb_kg} kg` },
    { key: "top", label: t("topSpeed"), value: s.top_speed ? `${s.top_speed} km/h` : "—" },
  ];
};
